import EmployeeManagerList from "./pages/ListPage.vue";
import EmployeeManagerDetail from "./pages/FormPage.vue";
import EmployeeManagerIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/employee_manager",
    component: EmployeeManagerIndex,
    redirect: "/employee_manager/list",
    name: "employee_manager",
    children: [
      {
        path: "list",
        component: EmployeeManagerList,
        name: "employee_manager.list",
      },
      {
        path: "create",
        component: EmployeeManagerDetail,
        name: "employee_manager.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: EmployeeManagerDetail,
        name: "employee_manager.edit",
        props: { create: false },
      },
    ],
  },
];
